var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagerLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9501\u5B9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-811.000000, -530.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u798F\\u5229\\u6A21\\u5757\\u5907\\u4EFD-3",
    transform: "translate(232.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u53F7\\u6253\\u4F4D\\u5907\\u4EFD-14",
    transform: "translate(482.800000, 222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9501\\u5B9A",
    transform: "translate(97.000000, 78.843461)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "suoding-6",
    transform: "translate(2.000000, 0.156539)",
    fill: "#0052D9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.48227025,6.32660347 L3.48227025,8.57678718 L5.51906984,8.52787014 L5.51906984,6.03310125 C5.51906984,3.8155289 7.34233398,2.00559852 9.5762432,2.00559852 L10.1511463,2.00559852 C12.3850555,2.00559852 14.2083197,3.8155289 14.2083197,6.03310125 L14.2083197,8.69092693 L16.2451193,8.65831557 L16.2451193,6.32660347 C16.2286934,2.85349383 13.3706037,0 9.85548185,0 C6.34035999,0 3.48227025,2.85349383 3.48227025,6.32660347 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0788872,8.05500545 C17.6413125,8.05500545 19.7109637,9.97907557 19.694635,12.3270934 L19.694635,12.3270934 L19.694635,18.7352252 C19.694635,21.0995487 17.6248867,23.0073131 15.0624614,23.0073131 L15.0624614,23.0073131 L4.63207647,23.0073131 C2.06965119,23.0073131 0,21.0995487 0,18.7352252 L0,18.7352252 L0,12.3270934 C0,9.97907557 2.06965119,8.05500545 4.63207647,8.05500545 L4.63207647,8.05500545 Z M9.85548185,13.4032682 C9.28057874,13.4032682 8.80423045,13.8435215 8.80423045,14.3653032 L8.80423045,14.3653032 L8.80423045,16.713321 C8.80423045,17.2351027 9.28057874,17.6753561 9.85548185,17.6753561 C10.430385,17.6753561 10.9067332,17.2351027 10.9067332,16.713321 L10.9067332,16.713321 L10.9067332,14.3653032 C10.9067332,13.8435215 10.430385,13.4032682 9.85548185,13.4032682 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerLock);
export default __webpack_public_path__ + "static/media/manager_lock.24b67bc1005c7373de6b0e74a49cec0a.svg";
export { ForwardRef as ReactComponent };